<!-- MENU PRINCIPAL -->
<div class="pages-shell-menu">
  <app-menubar></app-menubar>
</div>

<!-- BREADCRUMB -->
<div class="pages-shell-breadcrumb">
  <p-breadcrumb
    class="mybreadcrumb"
    [model]="comunService.getTitleBar()"
    [home]="comunService.home"
  ></p-breadcrumb>
</div>

<div class="pages-shell-content">
  <p-panel
    header=""
    [toggleable]="true"
    transitionOptions="400ms"
    class="wrapper animate__animated animate__fadeIn pages-shell-panel"
  >
    <router-outlet> </router-outlet>
  </p-panel>
</div>

